module.exports = __webpack_public_path__ + "static/we_emulate_people.77cae658.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sections/images/we_emulate_people.jpg
// module id = 510
// module chunks = 35783957827783